module.exports = __webpack_public_path__ + "img/Al.dd047ae7.svg";